export function checkPlatform(id) {
	switch (Number(id)) {
		case 1: return { path: require('../assets/platform/xhs.png'), name: '小红书' };
		case 2: return { path: require('../assets/platform/dy.png'), name: '抖音' };
		case 3: return { path: require('../assets/platform/wb.png'), name: '微博' };
		case 4: return { path: require('../assets/platform/wc.png'), name: '微信朋友圈' };
		case 5: return { path: require('../assets/platform/dzdp.png'), name: '大众点评' };
		case 6: return { path: require('../assets/platform/mfw.png'), name: '马蜂窝' };
		case 7: return { path: require('../assets/platform/wxgzh.png'), name: '微信公众号' };
		case 8: return { path: require('../assets/platform/wxsph.png'), name: '微信视频号' };
		// default :return {path:require('../assets/platform/questionnaire.png'),name:"问卷"}
		default: return {}
	}
}
// 导出excel后的推广平台数据
export const platformList = [
	{
		id: 1,
		nameList: ['小红书账号名', '', '', ''], // 一级标题
		typeList: ['小红书账号名', '粉丝数', '点赞数', '小红书链接'] // 二级标题
	},
	{
		id: 2,
		nameList: ['抖音', '', '', ''],
		typeList: ['账号名', '粉丝数', '点赞数', '链接']
	},
	{
		id: 3,
		nameList: ['微博', '', ''],
		typeList: ['微博昵称', '微博链接', '粉丝数']
	},
	{
		id: 4,
		nameList: ['微信朋友圈', ''],
		typeList: ['微信号', '微信好友数']
	},
	{
		id: 5,
		nameList: ['大众点评', '', '', ''],
		typeList: ['账号名', '粉丝数', '等级', '链接']
	},
	{
		id: 6,
		nameList: ['马蜂窝', '', ''],
		typeList: ['账号名', '粉丝数', '链接']
	},
	{
		id: 7,
		nameList: ['微信公众号', '', '', ''],
		typeList: ['账号', '类型', '所属', '粉丝数']
	},
	{
		id: 8,
		nameList: ['微信视频号', ''],
		typeList: ['名称', '粉丝数']
	},
]